import { idsOf, MigrationSpec } from "../migration.models"
import { MARKETPLACE_ACCOUNT_COLLECTIONS } from "./marketplace_collections"

const aiMarketplaceSkills: MigrationSpec = {
  type: "MIGRATE_AI_MARKETPLACE_SKILLS",
  collection: "Skills",
  risk: "SAFE",
  title: {
    en: "Marketplace-scoped skills → the MARKETPLACE role",
    tr: "Pazaryerine bağlı Skill'ler → MARKETPLACE rolü"
  },
  description: {
    en:
      "Gives the MARKETPLACE role every skill whose draft or published scope names a marketplace " +
      "account in `scope.channelIds`, so it still triggers on the marketplace questions that " +
      "role now answers. A skill scoped ONLY to marketplace channels moves to it; one that also " +
      "names another channel merely gains it. `roles` lives outside the versioned definition, so " +
      "nothing needs republishing.",
    tr:
      "Taslak veya yayınlanmış kapsamı `scope.channelIds` içinde bir pazaryeri hesabı adlandıran " +
      "her Skill'i MARKETPLACE rolüne verir; böylece bu rolün artık yanıtladığı pazaryeri " +
      "sorularında tetiklenmeye devam eder. YALNIZCA pazaryeri kanallarına bağlı Skill bu role " +
      "taşınır; başka bir kanalı da adlandıran Skill rolü yalnızca ek olarak alır. `roles` " +
      "versiyonlu tanımın dışında yaşar, bu yüzden yeniden yayınlama gerekmez."
  },
  affectedFilter: {
    roles: { $nin: ["MARKETPLACE"] },
    $or: [
      {
        "draftDefinition.scope.channelIds": {
          $in: idsOf(MARKETPLACE_ACCOUNT_COLLECTIONS)
        }
      },
      {
        "publishedDefinition.scope.channelIds": {
          $in: idsOf(MARKETPLACE_ACCOUNT_COLLECTIONS)
        }
      }
    ]
  },
  sampleFields: [
    "customer",
    "name",
    "roles",
    "draftDefinition.scope.channelIds",
    "publishedDefinition.scope.channelIds"
  ],
  preview: (doc) => {
    const roles = (doc.roles as string[] | undefined) ?? []
    return {
      ...doc,
      roles: roles.length ? [...roles, "MARKETPLACE"] : ["… + MARKETPLACE"]
    }
  },
  notes: [
    {
      en:
        "Both definitions are searched: a skill may carry the marketplace channel in its draft, " +
        "in what is published, or in both.",
      tr:
        "İki tanım da taranır: bir Skill pazaryeri kanalını taslağında, yayınlanmış hâlinde ya " +
        "da her ikisinde taşıyor olabilir."
    },
    {
      en: "`draftRevision` is not touched, so an editor open on the skill keeps working.",
      tr: "`draftRevision` değişmez; Skill'i açık tutan bir editör çalışmaya devam eder."
    }
  ]
}

export default aiMarketplaceSkills
